import React, { useEffect,useState } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import CryptidCard from './shared/cryptidCard'
import styled from 'styled-components'
import { scaleCenter } from './styled/animations'
import LalzerGun from "../assets/sounds/lazergun.mp3";

const GameSliderContainer = styled.section`
  position: relative;
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  bottom: calc(77px + var(--tg-safe-area-inset-bottom, 0px));
  padding-bottom: 8px;
`

const Viewport = styled.div`
  width: 100%;
    /* overflow: hidden; */
    padding: ${({cards}) => cards?.length <= 4 ? "32px 0" : "18px 0"};
`

const Container = styled.div`
  display: flex;
  align-items: center;
  backface-visibility: hidden;
  height: 100%;
`

const Slide = styled.div`
  flex: ${({cards}) => cards?.length <= 4 ? "0 0 33.33%" : "0 0 27%"};
  min-width: 0;
  position: relative;
  padding: 0 8px;
  height: 100%;

`

const Card = styled.div`
  width:100% ;
  height: auto;
  aspect-ratio: 859/1320;
  color: white;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  opacity: ${({is_active}) => is_active ? 1 : 0.5};
  animation:${({is_active}) => is_active ? scaleCenter : null} 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both; 
`


const GameSlider = ({cards}) => {
  const OPTIONS = { 
    align: 'center',
    loop: true,
  }
  
  const autoplayOptions = {
    delay: 3000,
    rootNode: (emblaRoot) => emblaRoot.parentElement,
  }

  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS, [Autoplay(autoplayOptions)])
  const [selectedIndex, setSelectedIndex] = React.useState(0)
  const [audio] = useState(new Audio(LalzerGun));

  useEffect(() => {
    if (!emblaApi) return
    emblaApi.on('select', () => {
        //  audio.play()
        setSelectedIndex(emblaApi.selectedScrollSnap())
    })
  },[emblaApi])



  return (
    <GameSliderContainer>
      <Viewport cards={cards} ref={emblaRef}>
        <Container>
          {React.Children.toArray(
            cards.map((card, index) => (
              <Slide onClick={()=>audio.play()} cards={cards}>
                <Card is_active={index === selectedIndex}>
                  <CryptidCard cryptid={card} />
                </Card>
              </Slide>
            ))
          )}
        </Container>
      </Viewport>
    </GameSliderContainer>
  )
}

export default GameSlider